import RequestBuilder from "../RequestBuilder";
import {Method} from "../enum/Method";
import {AnyColumnJson} from "../json/ColumnJson";
import {PredefinedOptionJson} from "../json/PredefinedOptionJson";
import {ColumnType} from "../enum/ColumnType";
import RequestSender from "../RequestSender"

export class ColumnRequests {
    static create(projectId: string, name: string, reference: string, type: ColumnType, helperText: string | null, predefinedOptions?: PredefinedOptionJson[], numberOfDecimalPlaces?: number): Promise<AnyColumnJson> {
        return new RequestBuilder(Method.Post, `projects/${projectId}/columns`)
            .withJson(
                {
                    name: name,
                    reference: reference,
                    type: type,
                    helperText: helperText,
                    predefinedOptions: predefinedOptions,
                    numberOfDecimalPlaces: numberOfDecimalPlaces,
                }
            )
            .buildAndSend()
    }

    static get(projectId: string, fieldId: string): Promise<AnyColumnJson> {
        return new RequestBuilder(Method.Get, `projects/${projectId}/columns/${fieldId}`)
            .buildAndSend()
    }

    static list(projectId: string): Promise<AnyColumnJson[]> {
        return new RequestBuilder(Method.Get, `projects/${projectId}/columns`)
            .buildAndSend()
    }

    static update(projectId: string,
                  fieldId: string,
                  name?: string,
                  reference?: string,
                  order?: number,
                  helperText?: string | null,
                  predefinedOptions?: PredefinedOptionJson[], numberOfDecimalPlaces?: number): Promise<AnyColumnJson> {
        return new RequestBuilder(Method.Put, `projects/${projectId}/columns/${fieldId}`)
            .withJson({
                name: name,
                reference: reference,
                order: order,
                helperText: helperText,
                predefinedOptions: predefinedOptions,
                numberOfDecimalPlaces: numberOfDecimalPlaces,
            })
            .buildAndSend()
    }

    static delete(projectId: string, fieldId: string): Promise<void> {
        return new RequestBuilder(Method.Delete, `projects/${projectId}/columns/${fieldId}`)
            .buildAndSend()
    }

    static deletePredefinedOption(projectId: string, fieldId: string, optionId: string): Promise<void> {
        return new RequestBuilder(Method.Delete, `projects/${projectId}/columns/${fieldId}/predefined-options/${optionId}`)
            .buildAndSend()
    }

    static exportCsvTemplate(id: string): Promise<ArrayBuffer> {
        const request = new RequestBuilder(Method.Get, `projects/${id}/columns/csv`)
            .build()
        return RequestSender.sendRequest(request, true)
    }
}